export default Object.freeze({
  DOOR_STATUSES: {
    OVERLOCKED: 'overlocked',
    TO_OVERLOCK: 'to overlock',
    REMOVE_OVERLOCK: 'remove overlock'
  }
});